__turbopack_context__.v({
  "actionButton": "styles-module-scss-module__CrFGvW__actionButton",
  "buttonWrapper": "styles-module-scss-module__CrFGvW__buttonWrapper",
  "caption": "styles-module-scss-module__CrFGvW__caption",
  "container": "styles-module-scss-module__CrFGvW__container",
  "content": "styles-module-scss-module__CrFGvW__content",
  "description": "styles-module-scss-module__CrFGvW__description",
  "desktopOnlyCaption": "styles-module-scss-module__CrFGvW__desktopOnlyCaption",
  "desktopOnlyIcon": "styles-module-scss-module__CrFGvW__desktopOnlyIcon",
  "featureItem": "styles-module-scss-module__CrFGvW__featureItem",
  "icon": "styles-module-scss-module__CrFGvW__icon",
  "isDoubleImage": "styles-module-scss-module__CrFGvW__isDoubleImage",
  "mobileVisible": "styles-module-scss-module__CrFGvW__mobileVisible",
  "text": "styles-module-scss-module__CrFGvW__text",
});
